export const AnnoucementPrompts = {
  generateText:
    "Write a clear and professional school announcement regarding a change in schedule.",
  continueWriting: "Add more details about why this change is happening.",
  fixSpellingGrammer: "Correct errors and improve tone for parents.",
  makeLonger: "Add logistical details and impact on children.",
  makeShorter: "Summarize in a few direct sentences.",
  translate: "Translate this message into the parent's preferred language.",
  tryAgain: "Rephrase with a softer tone or alternate headline.",
  changeTone: "Make it sound more urgent and respectful.",
};

export const PostPromts = {
  generateText:
    "Write a cheerful learning update highlighting today's activity and what the children learned.",
  continueWriting: "Add more about how the children responded to the activity.",
  fixSpellingGrammer:
    "Fix spelling and grammar while keeping a warm and professional tone.",
  makeLonger:
    "Add a few more engaging details about the activity and its educational value.",
  makeShorter: "Summarize this update in 2-3 friendly sentences.",
  translate: "Translate this message into the parent's preferred language.",
  tryAgain: "Rephrase with a different style or vocabulary for variety.",
  changeTone: "Make it more playful and parent-friendly.",
};

export const EventPrompts = {
  generateText:
    "Write an engaging description for an upcoming school event that excites parents and staff.",
  continueWriting: "Add more about what children will do at the event.",
  fixSpellingGrammer:
    "Clean up errors while keeping the tone festive and clear.",
  makeLonger:
    "Include details like time, location, and benefits for attendees.",
  makeShorter: "Make this event invite short and snappy.",
  translate: "Translate this message into the parent's preferred language.",
  tryAgain: "Rewrite with a different angle or headline.",
  changeTone: "Make it sound more formal and informative.",
};

export const ActiviyPrompts = {
  generateText:
    "Describe a learning activity that focuses on motor skills or creativity.",
  continueWriting: "Explain the child's reaction or engagement level.",
  fixSpellingGrammer: "Correct mistakes and ensure clarity.",
  makeLonger: "Add learning outcomes and how this supports development.",
  makeShorter: "Shorten this while keeping the educational takeaway.",
  translate: "Translate this message into the parent's preferred language.",
  tryAgain: "Regenerate with more variety or creative language.",
  changeTone: "Make it more nurturing and parent-centered.",
};

export const ObservationPrompt = {
  generateText:
    "Write a professional observation of a child demonstrating curiosity during an activity.",
  continueWriting: "Add more about how the child interacted with others.",
  fixSpellingGrammer:
    "Correct grammar and make it sound clinical yet friendly.",
  makeLonger: "Include details on context, triggers, or next steps.",
  makeShorter: "Summarize the observation in under 50 words.",
  translate: "Translate this message into the parent's preferred language.",
  tryAgain: "Rewrite using a different format or terminology.",
  changeTone: "Make it more empathetic and reflective.",
};

export const languages = [
  "Arabic",
  "English",
  "Tagalog",
  "Hindi",
  "Urdu",
  "Chinese",
  "French",
  "Turkish",
  "Spanish",
];
